<template>
  <li class="row-content" :class="containerClass">
    <span class="row-content--side" :class="{'t-xs': totalOwners > -1}">
      <i class="fa fa-user"></i>
      <span v-if="totalOwners > -1">{{ totalOwners | formatNumberShort}}</span>
    </span>

    <span v-line-clamp="lineClamp" class="row-content--main" @click.stop >
      <span v-if="isText" class="t-500">{{ text }} </span>
      <template v-if="renderWithLinkTo">
        <span v-for="(owner, index) in owners" :key="index" :class="{'pr-1' : owners.length -1 !== index }">
          <researcher-link v-if="index < maxItems || maxItems === -1"
            :researcher="getResearcher(owner)"
          >
          </researcher-link>
          <span v-if="(index < maxItems -1 && index !== owners.length -1) || (maxItems === -1 && index !== owners.length -1)">,</span>
          <span v-if="index === (owners.length -2) && isSlicedInMiddle" class="t-italic t-sm">&nbsp;....&nbsp;,</span>
          <span v-if="owners.length > maxItems && index === maxItems -1 && !isSlicedInMiddle">, ...</span>
        </span>
      </template>

      <span v-if="!renderWithLinkTo && !renderWithCountry" v-html="getOwnersAsString()" v-line-clamp="lineClamp"></span>

      <template v-if="!renderWithLinkTo && renderWithCountry">
        <div v-for="(owner, index) in owners" :key="index" class="position-relative d-inline">
          <span v-html="$options.filters.titleize(getOwnerName(owner))" ></span>
          <flag :title="renderCountryFlagTooltip(owner.country)" v-if="owner.country && owner.country.alpha_2" :iso="owner.country.alpha_2 | lowercase" :squared="false" class="bd-radius ml-1 mr-2 flag-positioning" />
        </div>
      </template>
    </span>
  </li>
</template>

<script>
import ResearcherLink from '@/components/researcher/Link'
export default {
  name: 'searchPartialOwnersAsLink',
  components: {
    ResearcherLink
  },
  props: {
    owners: {
      type: Array,
      required: true
    },
    totalOwners: {
      type: Number,
      default: -1
    },
    highlights: {
      type: Object,
      required: false,
      default: () => ({})
    },
    highlightKey: {
      type: String,
      required: false,
      default: 'owners.full_name'
    },
    highlightKeys: {
      type: Array,
      required: false,
      default: () => ([])
    },
    containerClass: {
      type: String,
      default: ''
    },
    lineClamp: {
      type: Number,
      default: -1
    },
    maxItems: {
      type: Number,
      required: false,
      default: 3
    },
    isSlicedInMiddle: {
      type: Boolean,
      required: false,
      default: false
    },
    isWithResearcherObject: {
      type: Boolean,
      default: false
    },
    renderWithLinkTo: {
      type: Boolean,
      default: true
    },
    renderWithCountry: {
      type: Boolean,
      default: false
    },
    isText: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Contact: '
    }
  },
  methods: {
    getOwnersAsString () {
      if (!this.owners) return ''

      let ownerStr = ''
      const ownerCount = this.owners.length
      for (const [key, value] of this.owners.entries()) {
        ownerStr += this.getOwnerName(value)
        if (key === (ownerCount - 2) && this.isSlicedInMiddle) ownerStr += ',&nbsp;...'
        if (key < ownerCount - 1) ownerStr += ', '
      }

      return ownerStr
    },
    getOwnerName (owner) {
      let key = 'full_name'
      if (this.isEmpty(owner[key])) key = 'name'
      if (this.isEmpty(owner[key])) key = 'author_name'
      if (this.isEmpty(owner[key])) key = 'participant_name'
      let member = owner[key]

      if (!this.isEmpty(this.highlights) && !this.isEmpty(this.highlightKeys)) {
        for (let highlightKey of this.highlightKeys) {
          if (this.highlights[highlightKey]) {
            for (let m of this.highlights[highlightKey]) if (owner[key] === this.stripTags(m)) member = m
          }
          return member
        }
      } else if (!this.isEmpty(this.highlights) && this.highlights[this.highlightKey]) {
        for (let m of this.highlights[this.highlightKey]) if (owner[key] === this.stripTags(m)) member = m
        return member
      }
      return this.getFullName(owner)
    },
    getResearcher (owner) {
      if (this.isWithResearcherObject && !this.isEmpty(owner.researcher)) {
        return this.getFullName(owner.researcher) !== this.getFullName(owner)
          ? owner
          : owner.researcher
      } else {
        return owner
      }
    }
  }
}
</script>
